import { useId } from 'react';

import { MoneyInput } from '../../../shared/ui/MoneyInput.js';
import styles from './QuickAddControls.module.css';

/**
 * The amount, at the top of Quick Add and impossible to miss. It is a real input, not a
 * display: tapping the digits opens the keyboard, and on a fresh screen it already has focus,
 * because that is most of the five seconds (spec v2 22.1).
 */
export function AmountCard({
  value,
  onChange,
  autoFocus,
}: {
  value: number | null;
  onChange: (amount: number | null) => void;
  autoFocus?: boolean;
}) {
  const inputId = useId();

  return (
    <section className={styles.amountCard}>
      <label className={styles.amountLabel} htmlFor={inputId}>
        Số tiền
      </label>
      <MoneyInput
        id={inputId}
        value={value}
        onChange={onChange}
        variant="hero"
        {...(autoFocus === undefined ? {} : { autoFocus })}
      />
    </section>
  );
}
